import {BaseConverter} from '../../base/converters/base-converter.converter';
import {Injectable} from '@angular/core';
import {CustomerModel} from '../models/customer.model';
import {Customer} from '../DTO/customer';
import {AccountConverter} from './account.converter';
import {AccountModel} from '../models/account.model';

@Injectable()
export class CustomerConverter extends BaseConverter<CustomerModel, Customer> {
  constructor(private accoountConverter: AccountConverter) {
    super();
  }

  convertToDto(model: CustomerModel): Customer {
    if (!model) {
      return null;
    }
    return {
      accounts: this.accoountConverter.convertToDtoList(model.accounts),
      businessName: model.businessName,
      customerCode: model.customerCode,
      status: model.status,
      unit: model.unit
    };
  }

  convertToModel(dto: Customer): CustomerModel {
    if (!dto) {
      return null;
    }
    let model: CustomerModel = new CustomerModel();

    model.accounts = this.accoountConverter.convertToModelList(dto.accounts);
    model.businessName = dto.businessName;
    model.customerCode = dto.customerCode;
    model.status = dto.status;
    model.unit = dto.unit;

    return model;
  }

  convertCustomerFormStorage(customerFromStorage: any): CustomerModel {
    let model = new CustomerModel();
    model.unit = customerFromStorage._unit;
    model.status = customerFromStorage._status;
    model.customerCode = customerFromStorage._customerCode;
    model.businessName = customerFromStorage._businessName;
    model.accounts = [];

    if (customerFromStorage._accounts) {
      for (let a of customerFromStorage._accounts) {
        let account: AccountModel = new AccountModel();
        account.accountCode = a._accountCode;
        account.customerCode = a._customerCode;
        account.description = a._description;
        account.mail = a._mail;
        account.mandatoryContract = a._mandatoryContract;
        account.status = a._status;
        account.unit = a._unit;
        account.id = a._id;
        model.accounts.push(account);
      }
    }
    return model;
  }
}
